import React, { useState } from "react";
import { useNotify, useRecordContext } from "react-admin";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  LinearProgress,
} from "@mui/material";
import VpnIcon from "@mui/icons-material/VpnKey";
import GennevApiService from "../../../services/gennev-api.service";
import { getImpersonationUrl } from "../../../services/impersonation-url";

export const ImpersonateButton = () => {
  const notify = useNotify();
  const [open, setOpen] = useState(false);
  const [loading, setIsLoading] = useState(false);

  const [composedName, setComposedName] = useState("");
  const record = useRecordContext();
  const handleClickOpen = () => {
    setOpen(true);
    const tmpName = record.first_name ?? record.email;
    setComposedName(tmpName);
  };

  const handleClose = () => {
    setOpen(false);
    setComposedName("");
  };

  const handleImpersonate = () => {
    setIsLoading(true);
    GennevApiService.impersonate(record.id)
      .then((data) => {
        const impersonationUrl = getImpersonationUrl({
          brand: data.brand,
          token: data.token,
          refreshToken: data.refresh_token,
          expiration: data.expiration,
        });
        notify("Impersonated and redirected to the user's brand", {
          type: "success",
        });
        window.open(impersonationUrl, "_blank", "noopener,noreferrer");
      })
      .catch((err) => {
        notify(err?.message || "Unexpected error", { type: "error" });
      })
      .finally(() => {
        setIsLoading(false);
        handleClose();
      });
    handleClose();
  };

  return (
    <>
      <Button
        color="primary"
        startIcon={<VpnIcon />}
        onClick={() => handleClickOpen()}
      >
        Impersonate
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Are you sure you want to impersonate ${composedName}?`}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <span>
              You're going to be redirected to Gennev site's and logged in as{" "}
              <b>{record.email}</b>.
            </span>
            <span style={{ marginTop: "10px", display: "block" }}>
              Be aware that all your actions are going to be recorded for
              auditing purposes.
            </span>
          </DialogContentText>
        </DialogContent>
        {loading ? <LinearProgress /> : null}
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={() => handleImpersonate()} color="primary" autoFocus>
            Yes, Impersonate
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
